import cn from 'classnames';
import { AiFillPrinter, AiOutlinePlus } from 'react-icons/ai';
import { IoMdSettings } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { SettingsIcon } from '../../../../../../assets/svg/settings';
import { SortIcon } from '../../../../../../assets/svg/sort';
import { Button } from '../../../../../../components/button/button';
import { Dropdown, DropdownOptionType } from '../../../../../../components/dropdown/dropdown';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { isMobile } from '../../../../../../helpers/devices';
import { concatPath } from '../../../../../../helpers/path';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { ManagerPath, QrCodesPath, RootPath } from '../../../../../../routes/manager/manager-enums';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useManagerStore } from '../../../../../../store/use-manager-store';
import { useTagStaffStore } from '../../../../../../store/use-tag-staff-store';
import { PrintQrModal } from './print-qr-modal/print-qr-modal';
import s from './qr-controls.module.css';
import { QrEditorModal } from './qr-editor-modal/qr-editor-modal';

export const QrsControls = () => {
  const { hasAccess } = useManagerStore();
  const { place: branches } = useBranchesStore();
  const { tags: tag } = useTagStaffStore();

  const { t, getLocale } = useLang();

  const {
    handleCloseModal: handleClosePrintModal,
    handleOpenModal: handleOpenPrintModal,
    isOpen: isOpenPrintModal,
  } = useModalParams('printQr');

  const {
    handleCloseModal: handleCloseEditorModal,
    handleOpenModal: handleOpenEditorModal,
    isOpen: isOpenEditorModal,
  } = useModalParams('imageEditor');

  return (
    <div className={s.feature}>
      <Dropdown
        closeOnSelect
        leftIcon={<SettingsIcon width={20} height={20} />}
        className="hide__M hide__S"
        options={
          [
            hasAccess('qr', ['write'])
              ? {
                  key: 'editor',
                  label: t('Редактор шаблонов'),
                  content: (
                    <IconButton variant="ghost">
                      <IoMdSettings />
                    </IconButton>
                  ),
                  onClick: () => handleOpenEditorModal(),
                }
              : null,

            {
              key: 'print',
              label: t('Печать'),
              content: (
                <IconButton variant="ghost">
                  <AiFillPrinter />
                </IconButton>
              ),
              onClick: () => handleOpenPrintModal(),
            },
          ].filter(Boolean) as DropdownOptionType[]
        }
      />
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at', dir: 'asc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По дате'),
            value: 'created_at',
            filter: 'datetime-range',
          },
          {
            label: t('По филиалам'),
            value: 'branch',
            filter: 'single-select',
            filterOptions: branches?.map((item) => ({
              id: String(item.id),
              value: getLocale(item.name),
            })),
          },
          {
            label: t('По должностям'),
            value: 'tags',
            filter: 'multi-select',
            filterOptions: tag,
          },
          {
            label: t('По названию'),
            value: 'name',
            filter: 'input',
            // suggestions: staticList?.map((item) => getLocale(item.name)),
          },
        ]}
      />
      <HasAccess service="qr" permissions={['write']}>
        <Link
          to={concatPath([RootPath.Manager, ManagerPath.QrCodes, QrCodesPath.CreateStatic])}
          data-testid="create-qr"
          className={cn(s.create, isMobile() && s.mobile)}
        >
          <Button fullWidth size="lg">
            <AiOutlinePlus />
            <span className="hide__M hide__S">{t('Создать QR-код')}</span>
          </Button>
        </Link>
      </HasAccess>

      {isOpenPrintModal && <PrintQrModal onClose={() => handleClosePrintModal()} />}
      <HasAccess service="qr" permissions={['write']}>
        {isOpenEditorModal && <QrEditorModal onClose={() => handleCloseEditorModal()} />}
      </HasAccess>
    </div>
  );
};
